import { gql } from '@apollo/client'

export const EDIT_GROUP = gql`
  mutation EditGroup($inputData: EditGroupInput!) {
    editGroup(inputData: $inputData) {
      id
    }
  }
`
